import React, { useEffect, useState } from 'react'
import './SingleTravel.min.css'
import { AiFillDelete, AiFillEdit, AiOutlineClose } from 'react-icons/ai'
import axios from 'axios';
import { Travel } from '../TravelsPlanned/model'
import Travels from '../Travels/Travels';
import Swal from 'sweetalert2'
import { ipAddress } from '../../ipAddress';

interface Thing {
  id: number;
  name: string;
  isDone: number;
}

interface Props {
  things: Thing[];
  setThings: React.Dispatch<React.SetStateAction<Thing[]>>;
  thing: Thing;
  travel: Travel;
}

const ShoppingTravel: React.FC<Props> = ({ things, setThings, thing, travel }) => {

  const [edit, setEdit] = useState<boolean>(false);
  const [editThing, setEditThing] = useState<string>(thing.name);
  const [addOption, setAddOption] = useState<boolean>(false);

  const handleChange = (id: number, isDone: number, city: string) => {
    if (isDone === 1) {
      isDone = 0
    } else {
      isDone = 1
    }
    axios.post(ipAddress + '/doneThingTravel', {
      id: id,

      isDone: isDone,
    })

    // setThings(things.map((thing) => thing.id == id ? {...thing, isDone: 0}: thing ))

  };




  const handleDelete = (id: number, name: string) => {
    Swal.fire({
      title: name,
      text: "Czy jesteś pewien, że chcesz usunąc ten element ?",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post('http://46.41.151.87:9000/deleteThingTravel', {
          id: id,
        })
        // setCosts(costs.filter((cost) => (cost.id !== id) ))
      }
    })

  }

 


  const handleEdit = (e: React.FormEvent, id: number) => {
    setAddOption(false)
    e.preventDefault();
    axios.post(ipAddress + "/editShoppingList", {
      thing: editThing,
      id: id,

    })
      .then((response) => {
      })
      .catch(function (error) {
        console.log("error!")

      })

    setEdit(false)
  }

  const close = () => {
    setEdit(false);
    setEditThing(thing.name)
  }
  const resize = () => {
    let element = document.getElementById("textAreaEditShopping")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }
  

  return (
    <div className='list'>
      <div className='done'>
        {thing.isDone == 1 ? (
          <span>
            <input type='checkbox' checked={true}
              onChange={() => handleChange(thing.id, thing.isDone, travel.city)}
            ></input>
            <s className='text'> {thing.name} </s>
          </span>

        ) : (
          <span>
            <input type='checkbox' checked={false}
              onChange={() => handleChange(thing.id, thing.isDone, travel.city)}
            ></input>
            <div className='icons'>
            <span className='edit' onClick={() => setEdit(true)} ><AiFillEdit /></span>
            <span className='delete' onClick={() => handleDelete(thing.id, thing.name)} ><AiFillDelete /></span>
            </div>
            <span className='text'> {thing.name} </span>
          
          </span>
        )
        }
       
      </div>



      {edit ? (
        <form className='editShoppingList' onSubmit={(e) => { handleEdit(e, thing.id) }}>
          <button type='button'  id='close' onClick={() => close()} >X</button>
          <p>Edytuj rzecz do kupienia</p>
          <div className='thing'>
            <label htmlFor="thing">Co: </label>
            <textarea id='textAreaEditShopping'
              rows={4}

              value={editThing}
              onChange={(e) => (resize(),  setEditThing(e.target.value))}
              onClick={() => resize()}
            ></textarea>
          </div>

          <button type='submit' id='submit'>OK</button>
        </form>
      ) : (
        <span></span>
      )
      }



    </div>


  )
}

export default ShoppingTravel